var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn -clear",on:{"click":_vm.openFollowersModal}},[_vm._t("default")],2),_vm._v(" "),(_vm.showModal)?_c('followers-modal',{attrs:{"authUserId":_vm.authUserId,"userName":_vm.userName,"followers":_vm.followers},on:{"close-modal":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }